import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import PublicApplication from "@/pages/PublicApplication";
import PublicSignContract from "@/pages/PublicSignContract";
import PublicSignAcordo from "@/pages/PublicSignAcordo";
import PaymentResult from "@/pages/PaymentResult";
import CobrancaDiaria from "@/pages/CobrancaDiaria";
import RotaCobranca from "@/pages/RotaCobranca";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Applications from "@/pages/Applications";
import Contracts from "@/pages/Contracts";
import ContractDetail from "@/pages/ContractDetail";
import Loans from "@/pages/Loans";
import Installments from "@/pages/Installments";
import Payments from "@/pages/Payments";
import Mensagens from "@/pages/Mensagens";
import Acordos from "@/pages/Acordos";
import NovoAcordo from "@/pages/NovoAcordo";
import Simulador from "@/pages/Simulador";
import Documents from "@/pages/Documents";
import Atendimentos from "@/pages/Atendimentos";
import PrimeiroAcesso from "@/pages/PrimeiroAcesso";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import PortalAdmin from "@/pages/PortalAdmin";
import Settings from "@/pages/Settings";
import Empresas from "@/pages/Empresas";
import ForgotPassword from "@/pages/ForgotPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Bloqueado from "@/pages/Bloqueado";
import PortalCliente from "@/pages/PortalCliente";
import { UpdateBanner } from "@/components/UpdateBanner";
import { useIdentidade } from "@/lib/identidade";

const IdentidadeBoot = () => { useIdentidade(); return null; };

const P = (C, master) => (
  <ProtectedRoute master={master}>
    <Layout>{C}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/criar-senha/:token" element={<AcceptInvite />} />
            <Route path="/bloqueado" element={<Bloqueado />} />
            <Route path="/portal" element={<PortalCliente />} />
            <Route path="/portal/:slug" element={<PortalCliente />} />
            <Route path="/solicitar-credito" element={<PublicApplication />} />
            <Route path="/solicitar-credito/:slug" element={<PublicApplication />} />
            <Route path="/assinar/:token" element={<PublicSignContract />} />
            <Route path="/acordo/:token" element={<PublicSignAcordo />} />
            <Route path="/pagamento/sucesso" element={<PaymentResult />} />
            <Route path="/pagamento/cancelado" element={<PaymentResult cancelled />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={P(<Dashboard />)} />
            <Route path="/cobranca-diaria" element={P(<CobrancaDiaria />)} />
            <Route path="/rota-cobranca" element={P(<RotaCobranca />)} />
            <Route path="/clientes" element={P(<Clients />)} />
            <Route path="/clientes/:id" element={P(<ClientDetail />)} />
            <Route path="/solicitacoes" element={P(<Applications />)} />
            <Route path="/contratos" element={P(<Contracts />)} />
            <Route path="/contratos/:id" element={P(<ContractDetail />)} />
            <Route path="/emprestimos" element={P(<Loans />)} />
            <Route path="/parcelas" element={P(<Installments />)} />
            <Route path="/pagamentos" element={P(<Payments />)} />
            <Route path="/mensagens" element={P(<Mensagens />)} />
            <Route path="/acordos" element={P(<Acordos />)} />
            <Route path="/acordos/novo" element={P(<NovoAcordo />)} />
            <Route path="/simular-contrato" element={P(<Simulador />)} />
            <Route path="/documentos" element={P(<Documents />)} />
            <Route path="/atendimentos" element={P(<Atendimentos />)} />
            <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
            <Route path="/relatorios" element={P(<Reports />)} />
            <Route path="/usuarios" element={P(<Users />)} />
            <Route path="/portal-admin" element={P(<PortalAdmin />)} />
            <Route path="/configuracoes" element={P(<Settings />)} />
            <Route path="/master" element={P(<Empresas />, true)} />
            <Route path="/empresas" element={<Navigate to="/master" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <UpdateBanner />
        <IdentidadeBoot />
      </AuthProvider>
    </div>
  );
}

export default App;
